'use strict';

var fs = require('fs');
var path = require('path');
var yaml = require('js-yaml');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var fs__default = /*#__PURE__*/_interopDefaultCompat(fs);
var path__default = /*#__PURE__*/_interopDefaultCompat(path);
var yaml__default = /*#__PURE__*/_interopDefaultCompat(yaml);

const fileExists = (filePath) => {
  let flag = true;
  try {
    fs__default.default.accessSync(filePath, fs__default.default.constants.F_OK);
  } catch {
    flag = false;
  }
  return flag;
};
const validateTechDocs = async (data, filePath) => {
  if (!data?.metadata?.annotations || !data?.metadata?.annotations["backstage.io/techdocs-ref"]) {
    return;
  }
  const techDocsAnnotation = data.metadata.annotations["backstage.io/techdocs-ref"];
  if (!techDocsAnnotation.includes("dir") || techDocsAnnotation.match(/^dir:.$/gm)) {
    return;
  }
  const mkdocsYamlPath = path__default.default.join(
    path__default.default.dirname(filePath),
    techDocsAnnotation.split(":")[1],
    "mkdocs.yaml"
  );
  const mkdocsYmlPath = path__default.default.join(
    path__default.default.dirname(filePath),
    techDocsAnnotation.split(":")[1],
    "mkdocs.yml"
  );
  if (!fileExists(mkdocsYamlPath) && !fileExists(mkdocsYmlPath)) {
    throw new Error(
      `Techdocs annotation specifies "dir" but file under ${mkdocsYamlPath}|${mkdocsYmlPath} not found`
    );
  }
  return;
};
const relativeSpaceValidation = async (fileContents, filePath, verbose) => {
  try {
    const data = yaml__default.default.loadAll(fileContents, null, { schema: yaml__default.default.CORE_SCHEMA });
    if (verbose) {
      console.log("Validating locally dependant catalog contents");
    }
    await Promise.all(
      data.map(async (it) => {
        await validateTechDocs(it, filePath);
      })
    );
  } catch (e) {
    throw new Error(`Error: ${e instanceof Error ? e.message : String(e)}`);
  }
};

exports.relativeSpaceValidation = relativeSpaceValidation;
//# sourceMappingURL=relativeSpaceValidation.cjs.js.map
